// ZH content — globals only (nav / footer / CTA / acknowledgement), per
// copy deck `00-globals.md`. Full page copy currently falls back to the
// reviewed English working defaults until a complete zh-CN copy pass is added.

const zh = {
  nav: {
    aria: '主导航',
    home: '首页',
    whatWeInvest: '我们投资什么',
    howWeInvest: '我们如何投资',
    about: '关于我们',
    contact: '联系',
    submitCta: '提交合作机会',
    pillars: {
      property: { label: '房地产开发', desc: '土地与开发机会。' },
      built: { label: '建成环境产业投资', desc: '构建与塑造建成环境的企业。' },
      innovation: { label: '创新与创投', desc: '地产科技、建造科技、人工智能与可持续建造。' },
    },
    language: { en: 'EN', zh: '中文', current: '中文', toggle: 'EN' },
  },
  footer: {
    entityTitle: '主体',
    navTitle: '导航',
    legalTitle: '法律',
    ctaTitle: '提交合作机会',
    ackTitle: '原住民土地致意',
    country:
      'Cyberate Investments 向全澳原住民土地的传统所有者与守护者致敬。我们向过去与现在的长者致敬，并尊重原住民与托雷斯海峡岛民人民延续至今的文化、精神与教育实践。',
  },
  cta: {
    submit: '提交合作机会',
    discuss: '洽谈合作',
  },
};

export default zh;
